import { _path } from "./headerNavigation";

export const editorOptions = { stylingMode: "filled" };

export const editorOptionsSelect = {
    valueExpr: "id",
    displayExpr: "name",
    searchEnabled: true
}

export const editorOptionsSelectClear = {
    ...editorOptionsSelect,
    showClearButton: true,
}

export const editorOptionsSwitch = {
    switchedOffText:"NO",
    switchedOnText:"SI",
}

export const editorOptionsNumberBox={
    showSpinButtons:true,
    showClearButton:true
}

export const editorOptionsNumberBox2={
    showSpinButtons:true,
}

export const editorOptsTextBoxPhone={
    mask: "0000-0000"
}

export const editorOptsTextBox={
    showClearButton:true
}

export const editorOptsDateBox={
    showClearButton:true,
    openOnFieldClick:true,
}

export const dataAccess = {
    none:0x0,
    access : 0x01,
    create : 0x02,
    update : 0x04,
    delete : 0x08
}
//ty
export const chartTypes = [
    'area' , 'bar' , 'line' , 'scatter' , 'spline' , 'splinearea' , 'stackedarea' , 'stackedbar' , 'stackedline' , 'stackedspline' , 'stackedsplinearea' , 'steparea' , 'stepline' 
]

//Accepted Values: 'Bright' | 'Harmony Light' | 'Ocean' | 'Pastel' | 'Soft' | 'Soft Pastel' | 'Vintage' | 'Violet' | 'Carmine' | 'Dark Moon' | 'Dark Violet' | 'Green Mist' | 'Soft Blue' | 'Material' | 'Office'

export const palettes = [
    'Bright' , 'Harmony Light' , 'Ocean' , 'Pastel' , 'Soft' , 'Soft Pastel' , 'Vintage' , 'Violet' , 'Carmine' , 'Dark Moon' , 'Dark Violet' , 'Green Mist' , 'Soft Blue' , 'Material' , 'Office'
]

export const resources = {
    usuarios : 1,  
    catalogos : 2,  
    facturacion : 3,  
    clients : 4,
    agenda : 5,
    inventario : 6,
    graduaciones : 7,
    sms : 8,
    closeBill : 9,
    app : 10,
    editarGraduaciones : 11,

    compra : 12,    
    ajuste : 13,
}

export const navigation = [
    { id: 3, text: 'Clientes', icon: 'group', pathname: `${_path.CLINICA}/clientes` },
    { id: 4, text: 'Agenda', icon: 'card', pathname: `${_path.CLINICA}/agenda` },
    { id: 5, text: 'Nueva factura', icon: 'money', pathname: `${_path.CLINICA}/facturas` }
];

export const urlImg = "https://clinicavalle.com/wp-content/uploads/2020/12/clinicavalle.com368slider.jpg";

export const formatDateTime = 'dd/MM/yyyy hh:mm a';
export const formatDate = 'dd/MM/yyyy';
